import React from 'react';
import { Text } from '@heartinternet/hi-ui';
import { Checkbox } from '@heartinternet/hi-ui';
import type { CodeToName, FeatureCategoriesByType, WebServerType } from './types';
import './HostingPackageTypeForm.css';

export interface Step2WebToolsProps {
  serverType: WebServerType;
  featureCategoriesByType: FeatureCategoriesByType;
  featureToName: CodeToName;
  /** Form-field name for the multi-value features (e.g. `features${id}` or `features0`). */
  featuresFieldName: string;
  features: Set<string>;
  onToggleFeature: (code: string, on: boolean) => void;
}

export const Step2WebTools: React.FC<Step2WebToolsProps> = ({
  serverType,
  featureCategoriesByType,
  featureToName,
  featuresFieldName,
  features,
  onToggleFeature,
}) => {
  /* v8 ignore start -- `?? []` fallback for partial backend data; always present in practice */
  const categories = featureCategoriesByType[serverType] ?? [];
  /* v8 ignore stop */
  return (
    <>
      {categories
        .filter(([, codes]) => codes.length > 0)
        .map(([categoryName, codes]) => (
          <fieldset key={categoryName} className="hi-ui-hosting-package-type-form__category">
            <div className="hi-ui-hosting-package-type-form__category-legend">
              <Text variant="heading-3" inline>
                {categoryName}
              </Text>
            </div>
            {codes.map((code) => (
              <Checkbox
                key={code}
                name={featuresFieldName}
                value={code}
                checked={features.has(code)}
                onChange={(e) => onToggleFeature(code, e.target.checked)}
                label={featureToName[code] ?? code}
              />
            ))}
          </fieldset>
        ))}
    </>
  );
};
